var popup = document.getElementById('custom-popup');
var popupTrigger = document.getElementById('popup-trigger');
var closePopup = document.getElementById('close-popup');
var popupContent = document.getElementById('shopify-section-template--22597666177340__custom_html_testimonials');
var testimonialsList = document.getElementById('shopify-section-template--22597666177340__testimonials_cx9743');

/**
 * Update Header Cart Counter
 * Conflict with Theme & UpCart with the header cart counter
 * This will reset the HTML to only include the number,
 * else the collection pages don't update when products are added
 */
function cartCountInit(){
  let $cartCountWrapper = $('.header__cart-count cart-count');
  let $productCount = $cartCountWrapper.find('span:not(.sr-only)');

  // console.log('>> CCInit 0');
  

  // Get count, remove all elements and then only add count
  if ( $productCount.length ) {
    let cartCountNum = $productCount.text();
    $cartCountWrapper.text(cartCountNum);

    // console.log('>> CCInit 1');

    // Add shadow root style tag to remove default animation
    if ($cartCountWrapper[0].shadowRoot) {
      var style = document.createElement( 'style' );
      style.innerHTML = 'span { transform: translateY(0px) !important; opacity: 1 !important; }';
      $cartCountWrapper[0].shadowRoot.appendChild( style );
      // console.log('>> CCInit SR');
    }
  }
}

// Yagi Short Variant description update

function yagiHideShortVariantDescriptionExcept(variant){
  document.querySelectorAll('.short-variant-description').forEach(el => {
    el.style.display = 'none';
  });

  const descriptionEl = document.querySelector(`.short-variant-description[data-variant-id="${variant}"]`);
  if (descriptionEl){ descriptionEl.style.display = 'block'; }
}

const queryString = location.search;
const urlParams = new URLSearchParams(queryString);
var variantId = '';

if(urlParams.get('variant')){
  variantId = urlParams.get('variant');
}

// yagiHideShortVariantDescriptionExcept(variantId);

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelector("input[type='hidden'].product-variant-id")) {
    document.querySelector("input[type='hidden'].product-variant-id").addEventListener('change', yagiShortVariantChanged);
  }
});

function yagiShortVariantChanged() {
  if (document.querySelector('.product-variant-id')?.value !== variantId) {
    variantId = document.querySelector('.product-variant-id')?.value;

    if(!variantId) { variantId == '' }
    yagiHideShortVariantDescriptionExcept(variantId);
  }
}

// Set up observer for changes
const shortObserver = new MutationObserver((mutations) => {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  if(variantId) {
    yagiHideShortVariantDescriptionExcept(variantId);
  }
});

shortObserver.observe(document.body, {
  subtree: true,
  childList: true
});

/**
 * Update Cart Counter Bubble
 */
async function updateCartCount(cartCount, lastCartCount) {

  // If no cart data, then get cart data
  if (!cartCount) {
    try {
      const response = await fetch('/cart.js'); // Fetch the cart data
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      
      // The total count of all items (sum of all quantities) is in cartData.item_count
      cartCount = cartData.item_count; 

    } catch (error) {
      console.error("Error fetching cart details:", error);
    }
  }

  console.log('>> updateCartCount');
  // console.log('LCC: ' + lastCartCount);
  // console.log('CC: ' + cartCount);
  
  // Cart Counter Wrapper
  let $cartCountWrapper = $('.header__cart-count cart-count');

  // Show if results else hide
  if (typeof cartCount !== 'undefined' && cartCount > 0  ) {
    $cartCountWrapper.css('opacity', '');
    $cartCountWrapper.removeClass('opacity-0'); // Show bubble

    console.log('>> UC > 0');

    // Check shadow root & style tag
    // Style tag removes the number animation
    if ($cartCountWrapper[0].shadowRoot) {
      const styleTag = $cartCountWrapper[0].shadowRoot.querySelector('style');

      // if no style tag, then add
      if (!styleTag) {
        var style = document.createElement( 'style' );
        style.innerHTML = 'span { transform: translateY(0px) !important; opacity: 1 !important; }';
        $cartCountWrapper[0].shadowRoot.appendChild( style );
      }
    }

    // Update count and animate bubble
    $cartCountWrapper.text(cartCount);
    $cartCountWrapper.addClass("count-updated");
    
    setTimeout(() => {
      $cartCountWrapper.removeClass("count-updated");
      // fallback check
      setTimeout(() => {
        $cartCountWrapper.removeClass("count-updated");
      }, 800);
    }, 300);
    
  } else {
    // console.log('>> UC else, hide');
    // hide bubble and text
    $cartCountWrapper.addClass('opacity-0');
    $cartCountWrapper.text('');
  }

  // Cart Cookie Update
  let $cartDrawer = $('#UpcartPopup');
  let cookie_products_cart = getCook('_cart_product_add');

  // Update product cart cookie only if product added & the drawer is not open
  if ( lastCartCount < cartCount && !$cartDrawer.hasClass('upcartPopupShow') ) {
    // console.log('>> Cookie update if >');
    productsCartCookie();
  }
  // Check if cart cookie exist
  if ( cookie_products_cart ) {
    // Reset cookie counter if cart empty
    if (typeof cartCount !== 'undefined' && cartCount == 0  ) {
      deleteCookie( '_cart_product_add', '/', '' );
    } 
  }
}
// Checkout page - Remove cart counter cookie
if (window.location.href.indexOf("checkouts") > -1){
    deleteCookie( '_cart_product_add', '/', '' );
}

/**
 * Monitor Cart Product Add
 * The 2 functions below triggers on different events
 */
document.addEventListener('product:added', function(event) {
  productAddedTextNotice();
});

/**
 * Monitor Cart Add changes - Triggers on some add to cart events
 */
(function() {
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        // Check if the request is an add-to-cart call
        if (args[0].includes('/cart/add.js')) {
            return originalFetch.apply(this, args).then(response => {
                // Your custom logic runs here after the item is successfully added
                // console.log('Cart addition network request completed.');
                // You might need to fetch the updated cart object via /cart.js to get details
                fetch('/cart.js')
                   .then(res => res.json())
                   .then(cart => {
                      //  console.log('Current cart state:', cart);
                       productAddedTextNotice();
                   });

                return response;
            });
        }
        return originalFetch.apply(this, args);
    };
})();
/* END - Product Add Notice */

/**
 * Product Added Text Notice
 * Update Add to cart button notice
 */
function productAddedTextNotice(){
  // If product single page
  if ( $('body.current-template--product').length || $('body.current-template--product-non-perishable').length || $('body.current-template--product-burger-box').length || $('body.current-template--product-golden-mother-gift-set').length) {
    // let $buy_btn = $('.product-info__buy-buttons button');
    let $buy_btn = $('.btn-atc-triggered');

    // Show text
    $buy_btn.addClass('added-to-cart');
    $buy_btn.append('<div class="added-to-cart-text">Added ✓</div>');

    // Remove text
    setTimeout(() => {
      $buy_btn.removeClass('btn-atc-triggered');
      $buy_btn.removeClass('added-to-cart');
      $buy_btn.find('.added-to-cart-text').remove();
    }, 2500);
  }

  // Cart Drawer Upsell
  if ( $('#upCart #up-upsell-carousel .upcart-upsells-button.btn-atc-triggered').length ) {
    let $buy_btn = $('#upCart #up-upsell-carousel .upcart-upsells-button.btn-atc-triggered');

    let cartIntervalId = setInterval(function() {

      if ( !$('#upCart #up-upsell-carousel .styles_PreviewCarousel__loader__').length ) {
        // Update input text
        $buy_btn.data('text', $buy_btn.val()).val('Added ✓');
        // Remove text
        setTimeout(() => {
          $buy_btn.removeClass('btn-atc-triggered');
          $buy_btn.val($buy_btn.data('text'));
          $('#upCart #up-upsell-carousel .control-next').trigger('click');
          // $buy_btn.closest('.slide').remove();
        }, 2500);

        // Stop the interval
        clearInterval(cartIntervalId);
      }
    }, 500); // Check every 500 milliseconds
  }
}

/**
 * Use products_cart cookie to monitor products added
 * Used to manually show cart drawer
 */
function productsCartCookie(){
  let cookie_products_cart = getCook('_cart_product_add');
  console.log('[] Cart COOKIE: ', cookie_products_cart);
  
  if ( cookie_products_cart ) {
    cookie_products_cart = JSON.parse(getCook('_cart_product_add'));
    cookie_products_cart = cookie_products_cart + 1;

    // Only open the cart when the 2nd product is added to the cart
    if ( cookie_products_cart == 2 ) {
      let $cartBtn = $('.shopify-section--header .cart-btn span');
      $cartBtn.trigger('click'); // open cart
    }

    // Update Cookie value
    document.cookie = "_cart_product_add="+cookie_products_cart+";path=/";
  } else {
    // Create cookie
    document.cookie = "_cart_product_add=1;path=/";
  }
  console.log('[] Cart Updated: ', JSON.parse(getCook('_cart_product_add')) );
}

// Add to cart triggered - Product single pages
// Main Add to cart & recommendations Add to cart
$('.product-info .product-info__buy-buttons, product-recommendations').on('click', '.button', function(event){
  $(this).addClass('btn-atc-triggered');
});

// Add to cart triggered - Cart Drawer Upsell products
$('#upCart').on('click', '.upcart-upsells-button', function(event){
  $(this).addClass('btn-atc-triggered');
});

/* END - Cart Count Manual update  */

/**
 * Get URL Param
 * getUrlParameter('param-name');
 */
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
// Show signup notice
function signupNotice(pStatus) {
  if ( pStatus == 'true' ) {
    const discount_code = 'GOAT10';
    let $discount_popup = $('.signup-notice-popup-container');
    $discount_popup.find('.discount-code-wrapper .code-text').html(discount_code);
    $discount_popup.find('.discount-code-wrapper .btn-copy').data('copy', discount_code);
    $discount_popup.addClass('active');
    // console.log( 'param: ' + getUrlParameter('customer_posted') );

    // Close button
    $discount_popup.find('.popup-close').on('click', function(event){
      event.preventDefault();
      $discount_popup.removeClass('active');
    });
    // copy content to clipboard
    btn_action_copy();
  }
}

/**
 * Scroll To animation
 */
jQuery.fn.scrollTo = function(elem, speed) { 
    $(this).animate({
        scrollTop:  $(this).scrollTop() - $(this).offset().top + $(elem).offset().top 
    }, speed == undefined ? 1000 : speed); 
    return this; 
};

/**
 * Content copy
 * When clicking on the element copy the action to clipboard
 */
function btn_action_copy() {
    let $action_menu = $('.action-copy-js');
    const discountCode = 'GOAT10'; // SET DISCOUNT CODE
    let $discount_popup = $('.signup-notice-popup-container');
    let $cartBtn = $('.shopify-section--header .cart-btn span');
    let $upCart = $('#upCart');
    // let $upCartDscountForm = $upCart.find('form.upcart-discount-code-row');
    let $upCartDscountField = $upCart.find('form.upcart-discount-code-row .upcart-discount-code-input');
    // let $upCartDscountBtn = $upCart.find('form.upcart-discount-code-row .upcart-discount-code-button');

  // Add to UpCart drawer - Testing
    // setTimeout(function() {
    //     // $discount_popup.removeClass('active');

    //   // localStorage.setItem('discount_code', discountCode); 
    //   // setCookie('mdev_cookie', 'test1', 1);
    //   // document.cookie = "discount_code="+discountCode;

    //   setTimeout(function() {
    //     // $upCartDscountField.val(discountCode); // add code to discount field
    //     // $cartBtn.trigger('click'); // open cart
    //     // $cartBtn.addClass('custom-click');
        

    //     setTimeout(function() {
    //       // $upCartDscountForm.trigger('submit');
    //       // $upCartDscountField.val(discountCode); // add code to discount field
    //     // $upCartDscountField.trigger("change"); // add code to discount field

    //       // setTimeout(function() {
    //       //   $upCartDscountBtn.trigger('click'); // Trigger apply button;
    //       // }, 1200);
    //     }, 800);
        
    //   }, 600);
        
    // }, 2000);
    
    // Copy on button click
    if ( $action_menu.length ) {
      $action_menu.on('click', function(e){
        e.preventDefault();
        let btn_action_copy = $(this).data('copy');

        // // Add new input field, used to copy the inner text to clipboard
        $(this).after( '<input class="btn-action-text" type="text" value="'+btn_action_copy+'">' ); // add new input with value
        let button_action_input = $(this).next('.btn-action-text');
        button_action_input.select(); // select input text
        document.execCommand("copy"); // copy to clipboard
        button_action_input.remove(); // remove element after copy

        // Close popup & open drawer
        $discount_popup.removeClass('active');
        $cartBtn.trigger('click'); // open cart
        // console.log('>> cart open');

        setTimeout(function() {
          $("#upCart #CartPopup").scrollTo('#upCart form.upcart-discount-code-row .upcart-discount-code-input', 1200);
          $('#upCart form.upcart-discount-code-row .upcart-discount-code-input').focus();
          // $('#upCart form.upcart-discount-code-row .upcart-discount-code-input').val(discountCode);
        }, 600);
        

        /**
         * Add discount to cart
         */
        // Discount code you want to apply
        // var discountCode = 'GOAT10'; 
        // let $upCart = $('#upCart');
        // let $upCartDscountField = $upCart.find('form.upcart-discount-code-row .upcart-discount-code-input').val(discountCode);

        // console.log('>> discountCode: ' + discountCode);

    });
  }
}

/**
 * Compare At Price Extend - Discount badge add
 * JS - Compare at on change 
 * CSS - label.block-swatch
 * price-list - title update
 */
// var CompareAtPrice = class extends HTMLElement {
//   constructor() {
//     super();
//     this._onVariantChangedListener = this._onVariantChanged.bind(this);
//   }
//   connectedCallback() {
//     document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
//   }
//   disconnectedCallback() {
//     document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
//   }
//   _onVariantChanged(event) {
//     const variant = event.detail.variant;
//     this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["compare_at_price"], currencyFormat)));
//     this.hidden = !(variant["compare_at_price"] > variant["price"]);
//     // 50% off 1 kilo sizes modified
//     if (variant["public_title"] == "1kg (Serves 45 - 50)"){
//       this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"], currencyFormat)));
//       this.hidden = false;
//     }
//   }
// };

// Last Dicount popup before checkout page 
// Add custom discounted price(red)
function updateDiscountedPrices() {
    if ($('.lb-addon-popup-container').length) {

      // Loop through all discounted prices
        $('.lb-upsell-money-2').each(function() {
            var $elem = $(this);

            // Check total price that gets added after product added
            if ($elem.closest('.lb-addon-popup-tot-price').length) {

                // set timeout to wait for total price to update
                setTimeout(function() {
                    var defaultPrice = parseFloat($elem.attr('default-price'));

                    // Check if price
                    if (!isNaN(defaultPrice)) {
                        var discountedPriceFormat = (defaultPrice * 0.7).toFixed(2);

                        // Add discounted price element before the default price
                        if ($elem.prev('.discounted-item').length === 0) { // Prevent duplicates
                            var $discountItem = $('<span class="discounted-item">$' + discountedPriceFormat + ' </span>');
                            $elem.before($discountItem);
                        }
                        // Update foarmetted text
                        $elem.prev('.discounted-item').text('$' + discountedPriceFormat + ' ');
                    }
                }, 100);
            } else {
              // Otherwise, show discounted price before element if not already present
                var defaultPrice = parseFloat($elem.attr('default-price'));

                if (!isNaN(defaultPrice)) {
                  var discountedPriceFormat = (defaultPrice * 0.7).toFixed(2);

                  // Check if custom elem added already, else add
                  if ($elem.prev('.discounted-item').length === 0) { // Prevent duplicates
                    var $discountItem = $('<span class="discounted-item" default-price="' + defaultPrice + '">$' + discountedPriceFormat + ' </span>');
                    $elem.before($discountItem);
                  } else {
                    // Check if the custom elem price is the same as default price 
                    var customDefaultPrice = $elem.prev('.discounted-item').attr('default-price');

                    // Compare prices and update if needed
                    if ( customDefaultPrice != defaultPrice ) {
                      // Update attr with new defaultPrice and update text with new formated text
                      $elem.prev('.discounted-item').attr("default-price", defaultPrice).text('$' + discountedPriceFormat + ' ');
                    }
                  }
                }
            }
        });
    }

    // CartDrawer Upsell
    if ( $('body.upcartPopupShow:not(.upsell-check)').length ) {
      // console.log('cartDrawer OPEN');
      cartUpSellChecker();
      $('body.upcartPopupShow').addClass('upsell-check');
    } else if ( $('body.upsell-check:not(.upcartPopupShow)').length ) {
      $('body.upsell-check').removeClass('upsell-check');
    }
}

// Observe DOM changes
const observer = new MutationObserver(function(mutationsList, observer) {
  // console.log('MO-DCP');
    updateDiscountedPrices();
});

observer.observe(document.body, { childList: true, subtree: true });

// Check if both elements exist before proceeding
if (popupContent && testimonialsList) {
  // Get the inner HTML of testimonialsList
  var testimonialsHTML = testimonialsList.innerHTML;
  
  // Set the inner HTML of popupContent to the HTML from testimonialsList
  popupContent.innerHTML = testimonialsHTML;

  // Update the target element's ID with the original element's ID
  popupContent.setAttribute('id', testimonialsList.id);

  popupTrigger.addEventListener('click', function() {
    popup.style.display = 'block';
  });
  
  popup.addEventListener('click', function() {
      popup.style.display = 'none';
  });
}

$('#shopify-section-template--22597666505020__featured-collection .product-card[handle="imperial-ossetra"] .product-card__figure .product-card__image').attr('src', 'https://cdn.shopify.com/s/files/1/0827/6184/3004/files/Product_ImperialOssetra_2x_66abf999-a6de-40d1-a60a-ce02cc85535e.png?v=1715240772');
$('#shopify-section-template--22597666505020__featured-collection .product-card[handle="imperial-ossetra"] .product-card__figure .product-card__image').attr('srcset', 'https://cdn.shopify.com/s/files/1/0827/6184/3004/files/Product_ImperialOssetra_2x_66abf999-a6de-40d1-a60a-ce02cc85535e.png?v=1715240772');

$('#shopify-section-template--22597666505020__featured-collection .product-card[handle="kaluga-grand-cru"] .product-card__figure .product-card__image').attr('src', 'https://cdn.shopify.com/s/files/1/0827/6184/3004/files/Product_KalugaGrandCru_2x_0fa3933f-2e56-4286-9d50-e51f6b2ec95d.png?v=1715240724');
$('#shopify-section-template--22597666505020__featured-collection .product-card[handle="kaluga-grand-cru"] .product-card__figure .product-card__image').attr('srcset', 'https://cdn.shopify.com/s/files/1/0827/6184/3004/files/Product_KalugaGrandCru_2x_0fa3933f-2e56-4286-9d50-e51f6b2ec95d.png?v=1715240724');

$('#shopify-section-template--22597666505020__featured-collection .product-card[handle="classic-ossetra"] .product-card__figure .product-card__image').attr('src', 'https://cdn.shopify.com/s/files/1/0827/6184/3004/files/Product_ClassicOssetra_2x_91d6b8d0-bd88-41d9-86b2-ce7e2fdd5894.png?v=1715240770');
$('#shopify-section-template--22597666505020__featured-collection .product-card[handle="classic-ossetra"] .product-card__figure .product-card__image').attr('srcset', 'https://cdn.shopify.com/s/files/1/0827/6184/3004/files/Product_ClassicOssetra_2x_91d6b8d0-bd88-41d9-86b2-ce7e2fdd5894.png?v=1715240770');

var product_title = $('#shopify-section-template--22597666734396__main .product-info .product-info__title').text().toLowerCase().replace(/\s/g, '-'); // Make product_title lowercase and remove spaces
// console.log(product_title);
$('#shopify-section-template--22597666734396__main .product-info').addClass('product-name-' + product_title);

// $('.cart-order .cart-order__summary .order-summary').append('<span class="cart-shipping-text js-alter">Enter DEC24 for 20% OFF</span>');

$('.cart-order .cart-order__summary .order-summary').append('<span class="cart-shipping-text">FREE OVERNIGHT SHIPPING with purchase of any caviar</span>');

// $('.cart-order .cart-order__summary .order-summary').append('<a class="continue-shopping-btn" href="/collections/all">Continue Shopping</a>');

$('.cart-order .cart-order__recap .prose.text-subdued p').append('<br><a id="returns-policy" href="/pages/terms-conditions#returns">View our Refund Policy</a>');

// Add banner at the top of the pages for the 10% off special
if($(window).width() >= 572){
  $('header.shopify-section--header').prepend('<div class="kilo-banner js-update">  <span>10% OFF YOUR FIRST ORDER | <a href="#" class="discount-modal-js">GET NOW</a></span>  <span class="separator mobile-hidden">•</span> <span>FREE OVERNIGHT SHIPPING.</span></div>');
}else{
  $('header.shopify-section--header').prepend('<div class="kilo-banner js-update">  <span><a href="#" class="discount-modal-js">10% Off First Order</a></span> | <span>Free Overnight Shipping.</span></div>');
}
// $('header').prepend('<div class="kilo-banner">  <span class="mobile-hidden">LIMITED TIME OFFERS</span>  <span class="separator mobile-hidden">•</span>  <span>10% OFF YOUR FIRST ORDER | <a href="#" class="discount-modal-js">GET NOW</a></span>  <span class="separator mobile-hidden">•</span>  <span class="mobile-hidden">LIMITED TIME OFFERS</span>  <span class="separator mobile-hidden">•</span>  <span>50% OFF ALL KILOS. HURRY!</span></div>');

// On "Get Now" clicked open discount popup
$('.kilo-banner a.discount-modal-js').on('click', function(event){
  event.preventDefault();
  // $('.kl-teaser-XF4pEa').trigger( "click" ); // klaviyo
  // let ssModal = $('.ss-modal-popup--section button').trigger( "click" ); // ss modal
  $('[class*="ss_modal_popup_MmTDW3"]').addClass('active'); // ss modal
});

// On "5.0 Excellent" clicked go to testimonials
$('[id*="ss_hero_32"] [class*="hero-review-text"] p, [id*="ss_hero_32"] [class*="hero-stars-review"] img').on('click', function(event){
  event.preventDefault();
  $([document.documentElement, document.body]).animate({
    scrollTop: $("[class*='ss_testimonial_12'").offset().top
  }, 800);
});

// On product page reviews clicked scroll down to reviews carousel
let justClicked = false;
let scrollPosition;
$('[id*="yotpo_product_reviews_reviews_carousel"] > div').append('<div class="yotpo-reviews-close">✖</div>');

setTimeout(() => {
  $('body.current-template--product .yotpo-reviews-star-ratings-widget .yotpo-widget-clear div, body.current-template--product-non-perishable .yotpo-reviews-star-ratings-widget .yotpo-widget-clear div').on('click', function(event){
    if ($('#yotpo-reviews-carousel-widget').length) {
      event.preventDefault();
      
      justClicked = true;    
      
      $('[id*="yotpo_product_reviews_reviews_carousel"] > div').css('display', 'block');
      $('[id*="yotpo_product_reviews_reviews_carousel"] .yotpo-reviews-close').css('display', 'block');
      $('body, html').css('overflow-y', 'hidden');
      // $('body').addClass('overlay--active');
      if (window.pageYOffset != 0) {
        scrollPosition = window.pageYOffset;
        // console.log(scrollPosition);
      }
      $('body').css('position', 'fixed');
    }

    // Previously used scroll to celebrity reviews code
    // $([document.documentElement, document.body]).animate({
    //   scrollTop: $("[class*='ss_product_reviews'").offset().top - 100
    // }, 800);
  });
}, 2000);

$('[id*="yotpo_product_reviews_reviews_carousel"] > div').on('click', function (event) {
  justClicked = true;
});

$('body.current-template--product, body.current-template--product, .yotpo-reviews-close').on('click', function (event) {
  
  if ($('[id*="yotpo_product_reviews_reviews_carousel"] > div').css('display') == 'block' && justClicked == false) {
    $('[id*="yotpo_product_reviews_reviews_carousel"] > div').css('display', 'none');
    $('[id*="yotpo_product_reviews_reviews_carousel"] .yotpo-reviews-close').css('display', 'none');
    $('body, html').css('overflow-y', 'unset');
    $('body').css('position', 'relative');
    window.scrollTo(0, scrollPosition);
  } else {
    justClicked = false;
  }
});

// Cart Checkout Custom
// if ( $('a.checkout-btn-js').length ) {
//   console.log('check btn');  
  
//   $('a.checkout-btn-js').on('click', function(event){
//     event.preventDefault();
//     let btn_action = $(this).data('action');
//     if ( btn_action == 'shipping-protection' ) {
//       console.log('checkout shipping js');
//       // Add Shipping
//     } else {
//       // remove shipping
//     }
//     // $('.kl-teaser-XF4pEa').trigger( "click" );
//   });
// }


// Add 50% off to the 1kg items variants titles
// Title changes - Guest to Serves (1kg (45 - 50 guests)) 
// $('.block-swatch:contains("1kg (Serves 45 - 50)")').append('<div class="kilo-discount">50% OFF</div>');

// Change order note text on cart page
$('.cart-form__note .floating-label').text("Order Note / Gift Message");

// disable Shipping protection product from being more than 1 copy of the item.
$('.cart-order .order-summary .is-base-product:contains("Shipping Protection") td .quantity-input').prop('disabled', true);

// Hide Shipping protection on the Cart Page
$('.cart-order .order-summary .is-base-product:contains("Shipping Protection")').hide();

// Change disclaimer on gift card product under buy now button
$('.product-name-golden-goat-gift-card .product-info__text .prose p').text("Gift Card recipient will receive email in the next two hours.");
$('.product-name-golden-goat-e-gift-card .product-info__text .prose p').text("Gift Card recipient will receive email in the next two hours.");

// Subtitle for prestige product
$('.product-name-the-prestige-collection-caviar-tasting-tin .product-info__price').after("<strong>The Prestige Collection Caviar Tasting Tin is a gift that says luxury with every bite.</strong>");
// $('.product-name-the-prestige-collection .product-info__title').after("<h2 class='product_subtitle'>Caviar Tasting Tin</h2>");

// Subtitle for Caviar butter
$('.product-name-artisanal-caviar-honey-butter .product-info__price').after("<strong>Pro Tip:&nbsp; Let sit at room temperature for approx 30 minutes before consuming for ultimate creaminess.</strong>");

// Close drawer menu when Best Sellers or Trending Gifts is clicked.
$( "navigation-drawer .panel ul li a :contains('Best Sellers'), navigation-drawer .panel ul li a :contains('Trending Gifts')" ).on( "click", function() {
  $( "navigation-drawer button[is='close-button']" ).click();
} );

// Add The "Free shipping on orders over 300" to products that are not .caviar or .gift-sets
// $('.shopify-section--main-product .product-info.caviar .product-info__block-item[data-block-type="text"] .prose p, .shopify-section--main-product .product-info.gift-sets .product-info__block-item[data-block-type="text"] .prose p').html('<strong>Free Overnight Shipping with purchase of any Caviar</strong>');

// Change shipping tab for .caviar and .gift-sets collections excluding caviar honey butter.
// $( document ).ready(function() {
//   // Update the Shipping tab for all Caviar and Gift sets except Caviar Honey Butter and caviar bump
//   if (!$('product-rerender[id^="product-info-9630305255740"], product-rerender[id^="product-info-10019530670396"]').length) {
//     $('.shopify-section--main-product .product-info.caviar .product-info__block-item [class*="tabs-items-template"] [data-id="tab_TcKNTK"], .shopify-section--main-product .product-info.gift-sets .product-info__block-item [class*="tabs-items-template"] [data-id="tab_TcKNTK"]').html('<ul><li>Free Overnight Shipping! - U.S. Only</li><li>Perishable.</li><li>Ships in an insulated styrofoam cooler with long lasting ice packs so your order is always fresh.</li></ul>');
//   }
// });

/**
 * Update all new tab links to inlcude noopener for added security
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[target="_blank"]').forEach(link => {
      // Check if it's an external link
      if (link.hostname !== location.hostname) {
          link.setAttribute('rel', 'noopener');
      }
  });
});

// Subtitle for Mothers day gift set
// $("[class*='product-name-mother'] .product-info__price").after("<strong>Enjoy three of our best caviars for an amazing low price!&nbsp; Save over $125.&nbsp; Offer is limited to one per customer.</strong>");

// Reminder to remove shipping protection when purchasing only a gift card
$('.product-name-golden-goat-gift-card .product-info__price').after("This is an E-Gift that will be sent via email. Please remember to deactivate premium shipping protection if you are only ordering an E-Gift Card.");
$('.product-name-golden-goat-e-gift-card .product-info__price').after("This is an E-Gift that will be sent via email. Please remember to deactivate premium shipping protection if you are only ordering an E-Gift Card.");
// $('.product-name-golden-goat-gift-card .product-info__price').after("Remember to deactivate premium shipping protection");

// Change celebrity influencer on the loved by everyone testimonials carousel
$('.swiper .swiper-wrapper .swiper-slide:contains("Nicole Amato") .celebrity-badge span').text('Influencer');

// Change subheading text on Collection pages
// $('#shopify-section-template--22597666177340__slideshow_HbjHEy p[data-sequence="subheading"]').html('<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192Z"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336L160 272"/></svg> Sustainably Farmed<br/><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192Z"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336L160 272"/></svg> No Preservatives <br/><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192Z"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336L160 272"/></svg> Never Pasteurized');

// Change empty cart text
setTimeout(() => {
  $('.styles_CartPreview__empty__').html('<h3 style="padding:20px;"><strong>Free Overnight Shipping</strong></h3>');
}, 500);

/**
 * Cart Drawer - Upsell Checker
 * Checks if the current upsell items shown are already added to cart
 * If the product is in the cart it will skip to the next available item
 */
function cartUpSellChecker() {

  jQuery.getJSON('/cart.js', function(cart) {

    const cartData = cart;

    let $cartUpSellWrapper = $('#upCart #up-upsell-carousel');
    let cartUpSellItems = [];
    let cartItems = [];
    
    // Cart get all items
    $.each(cartData.items, function(index, value) {
      let product_title = value.product_title;
      cartItems.push(product_title);
      // console.log("Index: " + index + ", Value: " + value);
    });

    // Get all Upsell items names
    let itemsSkip = 0;
    let availableItem = 0;
    // let itemSelectedIndex =  ($cartUpSellWrapper.find('.slide.selected:eq(0)').index() == 0) ? $cartUpSellWrapper.find('.slide.selected:eq(1)').index() : 1;
    let itemSelectedIndex =  1;

    if ( $cartUpSellWrapper.find('.slide.selected').length == 10 && $cartUpSellWrapper.find('.slide.selected').length > 1 ) {
      itemSelectedIndex = $cartUpSellWrapper.find('.slide.selected:eq(1)').index();
    } else {
      itemSelectedIndex = $cartUpSellWrapper.find('.slide.selected:eq(0)').index();
    }

    $cartUpSellWrapper.find('.slide').each(function(index, element) {

      if (index === 0) {
        return true; // Skip 1st item
      }
      
      let itemTitle = $(element).find('.upcart-upsell-item-title').text();
      let itemState = $(element).hasClass('selected');
      let itemInCart = $.inArray(itemTitle, cartItems);

      cartUpSellItems.push(itemTitle);

      if (itemInCart !== -1) {
        return true;
      } else {
        availableItem = index;
        return false;
      }
    });

    // Scroll to the available item
    if ( availableItem !== 0 ) {

      if (availableItem > itemSelectedIndex) {
        for (var i = itemSelectedIndex; i < availableItem; i++) {
          // Code to be executed in each iteration
          setTimeout(function () {
            $cartUpSellWrapper.find('.control-next').trigger('click');
          },150);
        }
      }

      if (availableItem < itemSelectedIndex) {
        for (var i = itemSelectedIndex; i > availableItem; i--) {
          // Code to be executed in each iteration
          setTimeout(function () {
            $cartUpSellWrapper.find('.control-prev').trigger('click');
          },150);
        }
      }
    }
  });
}


function monitorShopifyCart(onChange, interval = 2000) {
  let lastCart = null;
  let timer = null;

  async function fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) return null;
    return response.json();
  }

  async function checkCart() {
    try {
      const cart = await fetchCart();
      if (!cart) return;

      // console.log('>> CDM 0.0');

      if (JSON.stringify(cart) !== JSON.stringify(lastCart)) {
        // On page load set lastcart to the current cart
        if (lastCart === null) {
          lastCart = cart;
          onChange(cart);
          // console.log('>> CDM 1');
          updateCartCount(cartItem_count, lastCartItem_count);
        } else {
          let lastCartItem_count = lastCart.item_count;
          let cartItem_count = cart.item_count;
          lastCart = cart;
          onChange(cart);
          // console.log('>> CDM 2');
          // cartUpSellChecker(cart);
          
          // Update cart count manually
          updateCartCount(cartItem_count, lastCartItem_count);
        }
      } else if($('.styles_CartPreview__empty__').length) {
        // Update empty cart text
        $('.styles_CartPreview__empty__').html('<h3 style="padding:20px;"><strong>Free Overnight Shipping</strong></h3>');
      }
    } catch (e) {
      // Handle error if needed
    }
    timer = setTimeout(checkCart, interval);
  }

  checkCart();

  return () => clearTimeout(timer);
}

// update cart heading if product from certain collections/tags is in cart
function checkCartForTags(cart) {
  const targetTags = ['Free Shipping Eligible'];
  let found = false;

  if (!cart.items.length) {
    $('#additional_cart_heading').remove();
    return;
  }

  const requests = cart.items.map(item =>
    $.getJSON('/products/' + item.handle + '.js')
  );

  $.when.apply($, requests).then(function() {
    let products = [];
    if (requests.length === 1) {
      products = [arguments[0]];
    } else {
      products = Array.from(arguments).map(arg => arg[0]);
    }
    products.some(product => {
      if (product && product.tags) {
        const tags = product.tags;
        if (tags.some(tag => targetTags.includes(tag))) {
          found = true;
        }
      }
    });
    $('#additional_cart_heading').remove();
    $('.upcart-cart-body').children('div').eq(1).before('<div id="additional_cart_heading" class="styles_Announcement__">Free Overnight Shipping</div>');
    if (found) {
      $('#additional_cart_heading').text('Free Overnight Shipping');
    }
  });
}

// Start monitoring
const stopMonitoring = monitorShopifyCart(checkCartForTags);

/*
// reapply discounts on checkout page
if( $("body.current-template--cart").length ){
  // get original discount code
  var cookieValue = getCook('discount_code');
  console.log(cookieValue);

  // create cookie for original code
  document.cookie = "original_discount=" + cookieValue + ";path=/";
}

// on checkout page
if (window.location.href.indexOf("checkouts") > -1){
  var originalDiscount = getCook('original_discount');
  var currentDiscount = getCook('discount_code');
  console.log(currentDiscount);

  // Create new cookie with both codes
  document.cookie = "discount_code=" + originalDiscount + "," + currentDiscount + ";path=/";
}
*/

/**
 * Cookie Functions
 * Get and Delete Cookie
 */
function getCook(cookiename) {
  // Get name followed by anything except a semicolon
  var cookiestring=RegExp(cookiename+"=[^;]+").exec(document.cookie);
  // Return everything after the equal sign, or an empty string if the cookie name not found
  return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./,"") : "");
}

function deleteCookie( name, path, domain ) {
  if( getCook( name ) ) {
    document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}
/* End Cookie Functions */

/**
 * Product List - Product Title Updates
 * Loop through the product list and cards and update the product title
 */
function productListTitleUpdate() {
  let $product_list = $('.product-list');
  
  if( $product_list.length ) {
    
    // Loop through lists
    $product_list.each(function(list_index, list_elem) {
      let $product_list_elem = $(list_elem);

      // Loop through product cards
      $product_list_elem.find('.product-card').each(function(prod_index, prod_elem) {
        let $product_card = $(prod_elem);
        let $product_title = $product_card.find('.product-card__title a');

        if ( $product_title.length ) {
          let product_title = $product_title.html();
          // Check for newline text
          let product_title_new = productTitleNewLine(product_title);
           // Update title if changed
          if ( product_title_new ) {
            $product_title.html(product_title_new);
          }
        }
      });
    });
  }
}

/**
 * Product Title - New Line text
 * Wrap the text with a span
 */
function productTitleNewLine(product_title) {
  // Add list of new line text
  let newLineText = [
    'Caviar Tasting Tin'
    // 'Gift Set'
  ];
  let product_title_new = '';

  $.each(newLineText, function(text_key, text_val){
    if(product_title.indexOf(text_val) != -1){
      product_title_new = product_title.replace(text_val, "<span class='nl-txt'>"+text_val+"</span>");
    }
  });

  return product_title_new;
}

/**
 * Add Cookie Consent button
 * Adds a cookie button for the user to update their preferences again
 */
function cookie_consent_button(){
  // Get tracking consent cookie
  let cookie_banner = getCook('_tracking_consent');

  if ( cookie_banner ) {
    cookie_banner = JSON.parse(getCook('_tracking_consent'));
    // console.log('display_b: ' + cookie_banner.display_banner);
    // Only show button if display banner is false / user has already set their preference
    if ( cookie_banner.display_banner == false ) {
      let cookie_btn = "<div id='cookie-btn-js' onclick='javascript:privacyBanner.showPreferences()'></div>"; 
      $("body").append(cookie_btn); // add btn to body
    }
  }
}

/**
 * Delivery Shipping Notice Timer
 * Ref: https://github.com/caike/jQuery-Simple-Timer
 */
function delivery_notice_timer(){
  // To stop the continuous execution later:
  // clearInterval(delivery_notice_timer_intervalId);

  /*
  NB! if a friday is blocked off you will also have to block off the weekend days following it.
  */

  // Blocked off dates
  let blocked_dates = ['2026/9/8'];
  
  let current_date_check = new Date(new Date().toLocaleString('en', {timeZone: 'America/New_York'}));
  // let current_date_check = new Date(new Date('2025, 12, 10, 21:00:00').toLocaleString('en', {timeZone: 'America/New_York'})); // testing
  // current_date_check.setHours(01, 00, 0, 0); 
  let current_weekday = current_date_check.getDay();
  // current_weekday = 6; // debugging, force day

  // Get next tuesday
  // https://javascriptsource.com/get-the-date-for-a-specific-day-of-the-week/
  // The current day
	let now = current_date_check.getDay();
  
	// Find the difference between the current day and the one you want
	// If it's the same day as today (or a negative number), jump to the next week
	let diff = 2 - now; // 2 is the array for tuesday
	diff = diff < 1 ? 7 + diff : diff;
  
  // Get the timestamp for the desired day ( Tuesday )
  let nextTuesdayTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * diff);
  let nextTuesdayDate = new Date(nextTuesdayTimestamp);
  let nextTuesdayYear = nextTuesdayDate.getFullYear();  
  let nextTuesdayMonth = nextTuesdayDate.getMonth() + 1;
  let nextTuesdayDay = nextTuesdayDate.getDate();

  let nextTuesdayCompare = nextTuesdayYear + '/' + nextTuesdayMonth + '/' + nextTuesdayDay;
  
  // Get the timestamp for the next available date
  let dayAdvance = 2;
  let nextAvailableTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * dayAdvance);
  let nextAvailableDate = new Date(nextAvailableTimestamp);
  let nextAvailableYear = nextAvailableDate.getFullYear();  
  let nextAvailableMonth = nextAvailableDate.getMonth() + 1;
  let nextAvailableDay = nextAvailableDate.getDate();

  let nextAvailableCompare = nextAvailableYear + '/' + nextAvailableMonth + '/' + nextAvailableDay;

  let dayAvaialble = false;
  // check each blocked date if the next avaialble date falls on it
  for (let index = 0; index < blocked_dates.length; index++) {
    if (blocked_dates.includes(nextTuesdayCompare)) {      
      diff += 1;
      
      nextTuesdayTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * diff);
      nextTuesdayDate = new Date(nextTuesdayTimestamp);
      nextTuesdayYear = nextTuesdayDate.getFullYear();  
      nextTuesdayMonth = nextTuesdayDate.getMonth() + 1;
      nextTuesdayDay = nextTuesdayDate.getDate();

      nextTuesdayCompare = nextTuesdayYear + '/' + nextTuesdayMonth + '/' + nextTuesdayDay;
    }
    if (blocked_dates.includes(nextAvailableCompare)) {
      dayAdvance++;
      
      nextAvailableTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * dayAdvance);
      nextAvailableDate = new Date(nextAvailableTimestamp);
      nextAvailableYear = nextAvailableDate.getFullYear();  
      nextAvailableMonth = nextAvailableDate.getMonth() + 1;
      nextAvailableDay = nextAvailableDate.getDate();

      nextAvailableCompare = nextAvailableYear + '/' + nextAvailableMonth + '/' + nextAvailableDay;
    }
  }

  
  // console.log('mdate current main: ' + current_date_check);
  // console.log('mdate current main2: ' + current_date_check.toLocaleString('en', {timeZone: 'America/New_York'}));
  // console.log('mdate current wday: ' + current_weekday);
  // console.log('mdate tuesday timestamp: ' + nextTuesdayTimestamp);
  // console.log('mdate next Month timestamp: ' + nextAvailableMonth);
  // console.log('mdate next day timestamp: ' + nextAvailableDay);
  
  // Notice Messages
  let delivery_week_before_cutoff = 'Order by 3PM EST for Delivery Tomorrow';
  // let delivery_week_after_cutoff = 'Orders Placed now ship tomorrow for Next Day Delivery';
  let delivery_week_after_cutoff = 'Next Available Delivery Date: ' + nextAvailableMonth + '/' + nextAvailableDay;
  // let delivery_endofweek_after_cutoff = 'Orders Placed now ship Monday for Tuesday delivery';
  let delivery_endofweek_after_cutoff = 'Next Available Delivery Date: Tuesday ' + nextTuesdayMonth + '/' + nextTuesdayDay; // new message for endofweek cutoff

  // HTML
  let delivery_notice_html = "<div class='delivery-notice-wrapper'><div class='delivery-notice'></div>  <div class='delivery-timer-js'></div></div>";

  // Check day of the week
  // Sun-0, Mon-1,Tue-2,wed-3,Thur-4,Fri-5,Sat-6 
  if ( current_weekday == 5 || current_weekday == 6 || current_weekday == 0 ) {
    $('.delivery-notice-wrapper').addClass('show');
    $('.delivery-notice-wrapper .delivery-notice').text(delivery_endofweek_after_cutoff);
  } else {
    // Check if before or after cutoff time
    var delivery_cutoff = new Date(new Date().toLocaleString('en', {timeZone: 'America/New_York'}));
    // var delivery_cutoff = new Date(new Date('2025, 12, 17').toLocaleString('en', {timeZone: 'America/New_York'})); // testing
    // Set cut-off time
    delivery_cutoff.setHours(15, 00, 0, 0);
    // delivery_cutoff.setHours(09, 46, 0, 0); // debugging, force time

    let diff_mil = delivery_cutoff.getTime() - current_date_check.getTime();
    let totalSeconds = Math.floor(diff_mil / 1000);
    // let diff_hrs = Math.floor(totalSeconds / 3600); // 3600 seconds in an hour
    // let diff_min = Math.floor((totalSeconds % 3600) / 60);
    // let diff_sec = totalSeconds % 60;

    // debugging
    // console.log('mdate target_time: ' + delivery_cutoff);
    // console.log('mdate timeDiff(mil): ' + diff_mil);
    // console.log('mdate timeDiff(hrs): ' + diff_hrs);
    // console.log('mdate timeDiff(min): ' + diff_min);
    // console.log('mdate timeDiff(sec): ' + diff_sec);

    // Before Cutoff
    if (diff_mil > 0) {
      // console.log('time check - Before time');
      $('.delivery-notice-wrapper').addClass('show');
      $('.delivery-notice-wrapper .delivery-notice').text(delivery_week_before_cutoff);
      // $('.delivery-timer-js').data('minutes-left', 1);
      $('.delivery-timer-js').data('seconds-left', totalSeconds);
      $('.delivery-timer-js').startTimer({
        onComplete: function(){
          $('.delivery-notice-wrapper .delivery-timer-js').removeClass('show');
          if ( current_weekday == 4 ) {
            $('.delivery-notice-wrapper .delivery-notice').text(delivery_endofweek_after_cutoff);
          } else {
            $('.delivery-notice-wrapper .delivery-notice').text(delivery_week_after_cutoff);
          }
        }
      });
      $('.delivery-timer-js').addClass('show');
    } 
    // After Cutoff
    else {
      // console.log('time check - After time');
      $('.delivery-notice-wrapper').addClass('show');
      if ( current_weekday == 4 ) {
        $('.delivery-notice-wrapper .delivery-notice').text(delivery_endofweek_after_cutoff);
      } else {
        $('.delivery-notice-wrapper .delivery-notice').text(delivery_week_after_cutoff);
      }
    }
  }
}

var delivery_notice_timer_intervalId = setInterval(function() {
  // if ( $('#upCart .upcart-cart-body').length ) {
  //   if ( $('#upCart .upcart-cart-body .delivery-notice-wrapper:not(.show)').length ) {
  //     delivery_notice_timer();
  //   }
  // }
  
  $('.upcart-cart-body [id^="52647422001468"] .upcart-item-properties-anchor-before, .upcart-cart-body [id^="52647421968700"] .upcart-item-properties-anchor-before').text('$25 Credit Unlocked After Delivery');
  
}, 2500);

/**
 * Delivery Shipping Notice Timer
 * Ref: https://github.com/caike/jQuery-Simple-Timer
 */
function get_it_by_timer(){
  // To stop the continuous execution later:
  // clearInterval(delivery_notice_timer_intervalId);

  /*
  NB! if a friday is blocked off you will also have to block off the weekend days following it.
  */

  // Blocked off dates
  let blocked_dates = ['2026/6/8'];
  
  let current_date_check = new Date(new Date().toLocaleString('en', {timeZone: 'America/New_York'}));
  // let current_date_check = new Date(new Date('2026, 04, 13, 06:01:00').toLocaleString('en', {timeZone: 'America/New_York'})); // testing
  // current_date_check.setHours(22, 30, 0, 0); 
  let current_weekday = current_date_check.getDay();
  // current_weekday = 5; // debugging, force day

  // Get next tuesday
  // https://javascriptsource.com/get-the-date-for-a-specific-day-of-the-week/
  // The current day
	let now = current_date_check.getDay();
  
	// Find the difference between the current day and the one you want
	// If it's the same day as today (or a negative number), jump to the next week
	let diff = 2 - now; // 2 is the array for tuesday
	diff = diff < 1 ? 7 + diff : diff;
  
  // Get the timestamp for the desired day ( Tuesday )
  let nextTuesdayTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * diff);
  let nextTuesdayDate = new Date(nextTuesdayTimestamp);
  let nextTuesdayYear = nextTuesdayDate.getFullYear();  
  let nextTuesdayMonth = nextTuesdayDate.getMonth() + 1;
  let nextTuesdayDay = nextTuesdayDate.getDate();
  let nextTuesdayOfWeek = nextTuesdayDate.getDay();

  let nextTuesdayCompare = nextTuesdayYear + '/' + nextTuesdayMonth + '/' + nextTuesdayDay;
  
  // Get the timestamp for the next available date
  let dayAdvance = 1;
  let nextAvailableTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * dayAdvance);
  let nextAvailableDate = new Date(nextAvailableTimestamp);
  let nextAvailableYear = nextAvailableDate.getFullYear();  
  let nextAvailableMonth = nextAvailableDate.getMonth() + 1;
  let nextAvailableDay = nextAvailableDate.getDate();
  let dayOfWeek = nextAvailableDate.getDay();

  let nextAvailableCompare = nextAvailableYear + '/' + nextAvailableMonth + '/' + nextAvailableDay;

  // console.log('Next available Compare ' + nextAvailableCompare);

  // check each blocked date if the next avaialble date falls on it
  for (let index = 0; index < blocked_dates.length; index++) {
    if (blocked_dates.includes(nextTuesdayCompare)) {      
      diff += 1;
      
      nextTuesdayTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * diff);
      nextTuesdayDate = new Date(nextTuesdayTimestamp);
      // nextTuesdayYear = nextTuesdayDate.getFullYear();  
      nextTuesdayMonth = nextTuesdayDate.getMonth() + 1;
      nextTuesdayDay = nextTuesdayDate.getDate();
      nextTuesdayOfWeek = nextTuesdayDate.getDay();

    }
    if (blocked_dates.includes(nextAvailableCompare)) {
      dayAdvance++;
      
      nextAvailableTimestamp = current_date_check.getTime() + (1000 * 60 * 60 * 24 * dayAdvance);
      nextAvailableDate = new Date(nextAvailableTimestamp);
      // nextAvailableYear = nextAvailableDate.getFullYear();  
      // nextAvailableMonth = nextAvailableDate.getMonth() + 1;
      // nextAvailableDay = nextAvailableDate.getDate();
      dayOfWeek = nextAvailableDate.getDay();

    }
  }

  
  // console.log('mdate current timestamp: ' + current_date_check.getTime());
  // console.log('mdate current main: ' + current_date_check);
  // console.log('mdate current main2: ' + current_date_check.toLocaleString('en', {timeZone: 'America/New_York'}));
  // console.log('mdate current wday: ' + current_weekday);
  // console.log('mdate next tuesday timestamp: ' + nextTuesdayTimestamp);
  // console.log('mdate next tuesday Month: ' + nextTuesdayMonth);
  // console.log('mdate next tuesday day: ' + nextTuesdayDay);
  // console.log('mdate next available timestamp: ' + nextAvailableTimestamp);
  // console.log('mdate next Month: ' + nextAvailableMonth);
  // console.log('mdate next day: ' + nextAvailableDay);
  

  // Check day of the week
  // Sun-0, Mon-1,Tue-2,wed-3,Thur-4,Fri-5,Sat-6 
    // Check if before or after cutoff time
    var delivery_cutoff = new Date(new Date().toLocaleString('en', {timeZone: 'America/New_York'}));
    // var delivery_cutoff = new Date(new Date('2026, 04, 13, 14:00:00').toLocaleString('en', {timeZone: 'America/New_York'})); // testing
    // Set cut-off time
    delivery_cutoff.setHours(15, 00, 0, 0);
    // delivery_cutoff.setHours(15, 00, 0, 0); // debugging, force time

    console.log('delivery cutoff: ' + delivery_cutoff);
    
    let diff_mil = delivery_cutoff.getTime() - current_date_check.getTime();
    let totalSeconds = Math.floor(diff_mil / 1000);
    let diff_hrs = Math.floor(totalSeconds / 3600); // 3600 seconds in an hour
    let diff_min = Math.floor((totalSeconds % 3600) / 60);
    // let diff_sec = totalSeconds % 60;

    // next day cutoff
    let next_available_cutoff = new Date(new Date(nextAvailableTimestamp).toLocaleString('en', {timeZone: 'America/New_York'}));
    // let next_available_cutoff = new Date(new Date('2026, 04, 14, 14:00:00').toLocaleString('en', {timeZone: 'America/New_York'})); // testing
    next_available_cutoff.setHours(15, 00, 0, 0);
    let diff_available_day = next_available_cutoff.getTime() - current_date_check.getTime();
    let nextAvailable_totalSeconds = Math.floor(diff_available_day / 1000);
    let nextAvailable_diff_hrs = Math.floor(nextAvailable_totalSeconds / 3600);
    let nextAvailable_diff_min = Math.floor((nextAvailable_totalSeconds % 3600) / 60);

    // next tuesday cuttoff
    let next_tuesday_cutoff = new Date(new Date(nextTuesdayTimestamp).toLocaleString('en', {timeZone: 'America/New_York'}));
    next_tuesday_cutoff.setHours(15, 00, 0, 0);
    let diff_tuesday_day = next_tuesday_cutoff.getTime() - current_date_check.getTime();
    // let nextTuesday_totalSeconds = Math.floor(diff_tuesday_day / 1000);
    // let nextTuesday_diff_hrs = Math.floor(nextTuesday_totalSeconds / 3600);

    // console.log('mdate diff mil: ' + diff_mil);
    // console.log('mdate next available cutoff timestamp: ' + next_available_cutoff.getTime());
    // console.log('mdate next cutoff day: ' + diff_available_day);
    // console.log('mdate next cutoff hours: ' + nextAvailable_diff_hrs);
    // console.log('mdate next cutoff mins: ' + nextAvailable_diff_min);

    let monthLong = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let weekLong = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    let dayOrdinal = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th', '13th', '14th', '15th', '16th', '17th', '18th', '19th', '20th', '21st', '22nd', '23rd', '24th', '25th', '26th', '27th', '28th', '29th', '30th', '31st'];
    // Before Cutoff
    // Check day of the week
    // Sun-0, Mon-1,Tue-2,wed-3,Thur-4,Fri-5,Sat-6 
    if ( current_weekday == 5 || current_weekday == 6 || current_weekday == 0 ){
      $('div.nextAvailableDate').html(`<p class="intro-text" data="1">GET IT</p><p class="day_of_the_week"><strong><span style="text-transform:uppercase;">${weekLong[nextTuesdayOfWeek]}</span> ${monthLong[nextTuesdayMonth - 1]} <span class="normal_case">${dayOrdinal[nextTuesdayDay - 1]}</span></strong></p><p class="small-text"> or checkout other possible delivery dates in the shopping cart.</p>`);
      
    } else {
      if (diff_mil > 0) {
        if (diff_hrs > 0) {
          if (diff_min > 0) {
            // $('div.nextAvailableDate').html(`<p class="intro-text" data="2">GET IT</p><p class="day_of_the_week"><strong>THIS ${weekLong[dayOfWeek]}</strong></p><p class="shipping-text"><strong>FREE</strong> Overnight Shipping Included.</p><p class="order-within">ORDER WITHIN: <span class="countdown">${diff_hrs}h ${diff_min}m</span></p><p class="small-text">Choose another delivery date in the shopping cart if preferred.</p>`);
            $('div.nextAvailableDate').html(`<p class="intro-text" data="2">GET IT</p><p class="day_of_the_week"><strong>TOMORROW</strong></p><p class="shipping-text"><strong>FREE</strong> Overnight Shipping Included.</p><p class="order-within">ORDER WITHIN: <span class="countdown">${diff_hrs}h ${diff_min}m</span></p><p class="small-text">Choose another delivery date in the shopping cart if preferred.</p>`);
          } else {
            // $('div.nextAvailableDate').html(`<p class="intro-text" data="3">GET IT</p><p class="day_of_the_week"><strong>THIS ${weekLong[dayOfWeek]}</strong></p><p class="shipping-text"><strong>FREE</strong> Overnight Shipping Included.</p><p class="order-within">ORDER WITHIN: <span class="countdown">${diff_hrs}h</span></p><p class="small-text">Choose another delivery date in the shopping cart if preferred.</p>`);
            $('div.nextAvailableDate').html(`<p class="intro-text" data="3">GET IT</p><p class="day_of_the_week"><strong>TOMORROW</strong></p><p class="shipping-text"><strong>FREE</strong> Overnight Shipping Included.</p><p class="order-within">ORDER WITHIN: <span class="countdown">${diff_hrs}h</span></p><p class="small-text">Choose another delivery date in the shopping cart if preferred.</p>`);
          }
        } else {
          $('div.nextAvailableDate').html(`<p class="intro-text" data="3">GET IT</p><p class="day_of_the_week"><strong>TOMORROW</strong></p><p class="small-text">if you order in the next ${diff_min + 1}mins or checkout other possible delivery dates in the shopping cart.</p>`);
        }
      } else {
        // After Cutoff
        // Show next day
        if ( current_weekday == 4 ){
          $('div.nextAvailableDate').html(`<p class="intro-text" data="4">GET IT</p><p class="day_of_the_week"><strong><span style="text-transform:uppercase;">${weekLong[nextTuesdayOfWeek]}</span> ${monthLong[nextTuesdayMonth - 1]} <span class="normal_case">${dayOrdinal[nextTuesdayDay - 1]}</span></strong></p><p class="small-text"> or checkout other possible delivery dates in the shopping cart.</p>`);
        } else {
          if (nextAvailable_diff_min > 0) {
            $('div.nextAvailableDate').html(`<p class="intro-text" data="5">GET IT</p><p class="day_of_the_week"><strong>THIS ${weekLong[dayOfWeek + 1]}</strong></p><p class="small-text">if you order in the next ${nextAvailable_diff_hrs}hrs ${nextAvailable_diff_min}mins or checkout other possible delivery dates in the shopping cart.</p>`);
          } else {
            $('div.nextAvailableDate').html(`<p class="intro-text" data="6">GET IT</p><p class="day_of_the_week"><strong>THIS ${weekLong[dayOfWeek + 1]}</strong></p><p class="small-text">if you order in the next ${nextAvailable_diff_hrs}hrs or checkout other possible delivery dates in the shopping cart.</p>`);

          }
        }
      }
    }

    // debugging
    // console.log('mdate target_time: ' + delivery_cutoff);
    // console.log('mdate timeDiff(mil): ' + diff_mil);
    // console.log('mdate timeDiff(hrs): ' + diff_hrs);
    // console.log('mdate timeDiff(min): ' + diff_min);
    // console.log('mdate timeDiff(sec): ' + diff_sec);


}

if ( $('div.nextAvailableDate').length ) {
  var get_it_by_timer_interval = setInterval(function() {
    get_it_by_timer();
  }, 60000);
  get_it_by_timer();
}

// Remove duplicate price from the gift card quick buy
// .text().split('.00')[0];

// $('div.add-to-cart-quick[data-handle="golden-goat-gift-card"] div.addtc-button').click(function (){
//   setTimeout(function() {
//     console.log($(this).find('li span'));
//   }, 800);
// });

// Check if in viewport
$.fn.isInViewport = function() {
    var element = $(this);
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    var elementTop = element.offset().top;
    var elementBottom = elementTop + element.outerHeight();

    // Check if any part of the element is within the viewport
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Mute/pause Videos on scroll
$(window).scroll(function() {
  $('[id*="media_with_text"] video').each(function() {
      if ($(this).isInViewport() != true) {
        $(this).get(0).pause();
      }
  });
});

// Window Load
$(window).on("load", function () {

  // Cart Counter - Initial changes
  cartCountInit();

  // Four Caviars. One Extraordinary Gift section
  if ( $('[id*="media_with_text_iNcyjx"]').length ) {
      $('[id*="media_with_text_iNcyjx"] .media-with-text__media video-media').on('click', function () {
      $('[id*="media_with_text_iNcyjx"] .media-with-text__media video-media').addClass('video-played');
      $('[id*="media_with_text_iNcyjx"] .media-with-text__content').addClass('video-played');
    });
    
    if ($('body').hasClass('current-template--index')) { 
      var video = document.querySelector('[id*="media_with_text_iNcyjx"] .media-with-text__media video-media video');
      $('[id*="media_with_text_iNcyjx"] .media-with-text__media video-media video').attr('poster', '//goldengoatcaviar.com/cdn/shop/files/Jonathan_Cheban_500x1000_fa1b036e-8913-464b-91c4-3644a1943d64.jpg?v=1755525745&width=500');
      video.addEventListener('ended', function(){
        video.load();
      });
    }
  }

  // Fix Best sellers arrow on click not closing the menu
  $('#header-sidebar-menu .panel-list__wrapper .panel__scroller ul.menu-links li a .circle-chevron').on('click', function (e) {
    $(this).siblings().click();
  });

  // show more buttons
  // product-info__liquid
  $('.product-info__liquid').on('click', '.show-more-btn--js button', function(event){
    event.preventDefault();
    let $content_wrapper = $(this).closest('.has-show-more-content');
    let btn_status = $(this).data('type');

    if ( btn_status == 'more' ) {
      $content_wrapper.addClass('show-more--active');
    } else if ( btn_status == 'less' ) {
      $content_wrapper.removeClass('show-more--active');
      $([document.documentElement, document.body]).animate({
        scrollTop: $("[class*='ss_product_tabs_2'").offset().top - 200
      }, 500);
    }

    // if ( $content_wrapper.hasClass('show-more--active') ) {
    //   $content_wrapper.removeClass('show-more--active');
    // } else {
    //  $content_wrapper.addClass('show-more--active');
    // }
  });
  
  // Check if Admin user - Debugging(can use for styling)
  // if ( $('#admin-bar-iframe').length ) {
  //   $('body').addClass('is-admin');
  // }

  // Check if added to mailing list - Testing
  if (getUrlParameter('customer_posted')) {
    signupNotice( getUrlParameter('customer_posted') );
  }

  // signupNotice( 'true' );

  // Compare At Price
  // if (!window.customElements.get("compare-at-price")) {
  //   console.log('>> compare-at-price');
  //   window.customElements.define("compare-at-price", CompareAtPrice);
  // }

  /* Variant change debug */
  // document.addEventListener('variant:change', function(event) {
  //   const variant = event.detail.variant;
  //   // 'variant' is an object containing all the variant data
  //   console.log('Variant changed:', variant);
  
  //   // Example: Accessing specific variant properties
  //   console.log('Variant ID:', variant.id);
  //   console.log('Variant title:', variant.title);
  //   console.log('Variant price:', variant.price);
  //   console.log('Variant available:', variant.available);
  
  //   // Add your custom logic here, such as updating the product description,
  //   // displaying additional variant-specific information, etc.
  // });

  
  // Cookie Consent Button
  // cookie_consent_button();
  
  // Product List - Titles Update
  productListTitleUpdate();

  // Partner Logos
  // let $partner_logos_section = $('#shopify-section-template--22597666505020__logo_list_XdbPQP');
  

  // if ( $partner_logos_section.length ) {
  //   // Logos slider
  //   var animDuration = 3000; // Set the time delay in seconds
  //   var currentIndex = 0;
  //   var iterationCount = 0; // Variable to track the iteration count
  //   var logos = $partner_logos_section.find('.logo-list .logo-list__item');
  //   function updateLogos() {
  //     logos.each(function (i) {
  //       var $logo = $(this);
  //       var nextIndex;
  //       nextIndex = (currentIndex + i + 6) % logos.length;
        
  //       var nextLogoSrc = $(logos[nextIndex]).find("img").attr("src");
  //       var nextLogoSrcSet = $(logos[nextIndex]).find("img").attr("srcset");

  //       // Check if the logo is changing
  //       setTimeout(function () {
  //         // Ensure the nextLogo is not undefined before proceeding
  //         if (nextLogoSrc !== undefined && $logo.find("img").attr("src") !== nextLogoSrc) {
  //           setTimeout(function () {
  //             // After animation duration, update the logo
  //             $logo.find("img").attr("src", nextLogoSrc);
  //             $logo.find("img").attr("srcset", nextLogoSrcSet);
  //           }, i * 100); // Animation duration
  //         }
  //       }, 300);
  //     });
  //     setTimeout(function () {
  //       // Add class after animation duration
  //       logos.addClass("anim");
  //     }, 0); // Delay the addition of the class to the next tick of the event loop
  //     setTimeout(function () {
  //       // Remove class after animation duration
  //       logos.removeClass("anim");
  //     }, 1100); // Remove the class after 1100 milliseconds

  //     iterationCount++; // Increment the iteration count
  //   }

  //   // Delay the start of the animation by 3 seconds
  //   setTimeout(function () {
  //     updateLogos(); // Initial call to update logos

  //     setInterval(function () {
  //       updateLogos(); // Call updateLogos function periodically to update logos
  //     }, animDuration);
  //   }, animDuration); // Start after 4 seconds
  // }

  // Testimonials new
  let $testimonials_section = $('#shopify-section-template--22597666177340__testimonials_cx9743');


  if ( $testimonials_section.length ) {
    // Logos slider
    var animDuration = 5000;
    var currentIndex = 0;
    var iterationCount = 0; // Variable to track the iteration count
    var testimonials = $testimonials_section.find('.testimonial');
    function updateTestimonials() {
      testimonials.each(function (i) {
        var $testimonial = $(this);
        if ($(window).width() > 700) {
          var nextIndex = (currentIndex + i + 3) % testimonials.length;
        } else {
          var nextIndex = (currentIndex + i + 1) % testimonials.length;
        }
        

        var nextTestimonial = $(testimonials[nextIndex]); // Get the next testimonial element
        var nextHStack = nextTestimonial.find('.h-stack').html(); // Find .h-stack within the next testimonial
        var nextVStack = nextTestimonial.find('.v-stack.primary').html(); // Find .v-stack within the next testimonial
        

        // Check if the testimonial is changing
        setTimeout(function () {
          // Ensure the nextLogo is not undefined before proceeding
          if (nextHStack !== undefined && $testimonial.find('.h-stack').html() !== nextHStack) {
            setTimeout(function () {
              // After animation duration, update the testimonial
              $testimonial.find('.h-stack').html(nextHStack);
              $testimonial.find('.v-stack.primary').html(nextVStack);
            }, i * 100); // Animation duration
          }
        }, 300);
      });
      setTimeout(function () {
        // Add class after animation duration
        testimonials.addClass("anim");
      }, 0); // Delay the addition of the class to the next tick of the event loop
      setTimeout(function () {
        // Remove class after animation duration
        testimonials.removeClass("anim");
      }, 1100); // Remove the class after 1100 milliseconds

      iterationCount++; // Increment the iteration count
    }

    // Delay the start of the animation by 3 seconds
    setTimeout(function () {
      updateTestimonials(); // Initial call to update logos

      setInterval(function () {
        updateTestimonials(); // Call updateLogos function periodically to update logos
      }, animDuration);
    }, animDuration); // Start after 4 seconds
  }

  // Add badges to images 1 and 2 of burger box
  $('.current-template--product-burger-box media-carousel .product-gallery__media:nth-child(1), .current-template--product-burger-box media-carousel .product-gallery__media:nth-child(2)').append('<div class="product-card__badge-list"><span class="badge badge--primary">Most Popular</span></div>');
  
  // Add badges to images 3 and 4 of burger box
  $('.current-template--product-burger-box media-carousel .product-gallery__media:nth-child(3), .current-template--product-burger-box media-carousel .product-gallery__media:nth-child(4)').append('<div class="product-card__badge-list"><span class="badge badge--primary">Bougie Edition</span></div>');
  
  // Add $25 credit after title on collection page for burger box
  $('.current-template--collection product-card[handle="billionaire-burger-box"] .product-card__info .rating-with-text').after('<div style="font-style: italic;">$25 Caviar Credit Included</div>');
});

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get("cart") === "open") {
    const cartBtn = document.querySelector('a.cart-btn');

    if (cartBtn) {
      cartBtn.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }
});

if (window.location.pathname.includes('/pages/reorder') && window.location.search.includes('items=')) {
  const params = new URLSearchParams(window.location.search);
  const cleaned = params.get('items').replace(/\.0/g, '');
  window.location.replace('/cart/' + cleaned);
}